export default function Footer() {
  return (
    <footer className="bg-[#1e293b] py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/a3b81742d90ab9f1e4ddf3ee0c6174cb.png"
              alt="Atlas AI Services"
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Precision AI infrastructure for operational excellence.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <a href="#industries" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Home Services
                </a>
              </li>
              <li>
                <a href="#industries" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Financial Services
                </a>
              </li>
              <li>
                <a href="#framework" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Implementation
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About
                </a>
              </li>
              <li>
                <a href="#results" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Results
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">Connect</h4>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-gray-600 text-gray-400 hover:text-white hover:border-white transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-gray-600 text-gray-400 hover:text-white hover:border-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400 mb-4 md:mb-0">
            © 2025 Atlas AI Services. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}